import React from 'react'
import { format, startOfToday, addDays, subDays, endOfWeek, startOfWeek, eachDayOfInterval, add } from 'date-fns'
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, EllipsisHorizontalIcon } from '@heroicons/react/20/solid'
import { Menu, Transition } from '@headlessui/react'

function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const InternalCalendarMenu = ({view, setView, selectedDay, setSelectedDay, calendarDaysWithEvents, setFirstDayOfWeek, setLastDayOfWeek, setDisplayedWeek, lastDayOfWeek, firstDayOfWeek, firstDayOfCurrentMonth, setCurrentMonth, currentMonth, monthName}) => {

    const forwardOneDay = (e) => {
        setCurrentMonth(format(e, 'MMMM yyyy'))
        let formattedDay = format(e, 'yyyy-MM-dd')
        setTimeout(() => {
          setSelectedDay({date: formattedDay, events: calendarDaysWithEvents[formattedDay].events, availabilities: calendarDaysWithEvents[formattedDay].availabilities})
        }, 0)
      }
    
      const backOneDay = (e) => {
        setCurrentMonth(format(e, 'MMMM yyyy'))
        let formattedDay = format(e, 'yyyy-MM-dd')
        setTimeout(() => {
          setSelectedDay({date: formattedDay, events: calendarDaysWithEvents[formattedDay].events, availabilities: calendarDaysWithEvents[formattedDay].availabilities})
        }, 0)
      } 
    
      const jumpToToday = (e) => {
        setCurrentMonth(format(e, 'MMMM yyyy'))
        let formattedDay = format(e, 'yyyy-MM-dd')
        setTimeout(() => {
          setSelectedDay({date: formattedDay, events: calendarDaysWithEvents[formattedDay].events, availabilities: calendarDaysWithEvents[formattedDay].availabilities})
        }, 0)
      }

      const changeWeek = (day) => {
        setLastDayOfWeek(endOfWeek(day))
        setFirstDayOfWeek(startOfWeek(day))
        setDisplayedWeek(eachDayOfInterval({start: startOfWeek(day), end: endOfWeek(day)}))
      }

      const nextMonth = () => {
        let firstDayOfNextMonth = add(firstDayOfCurrentMonth, { months: 1})
        setCurrentMonth(format(firstDayOfNextMonth, 'MMMM yyyy'))
      }
    
      const prevMonth = () => {
        let firstDayOfNextMonth = add(firstDayOfCurrentMonth, { months: -1})
        setCurrentMonth(format(firstDayOfNextMonth, 'MMMM yyyy'))
      }

      const flipBack = (e) => {
        view === 'Day view' && backOneDay(e)
        view === 'Week view' && changeWeek(subDays(new Date(firstDayOfWeek), 1))
        view === 'Month view' && prevMonth()
      }

      const flipForward = (e) => {
        view === 'Day view' && forwardOneDay(e)
        view === 'Week view' && changeWeek(addDays(new Date(lastDayOfWeek), 1))
        view === 'Month view' && nextMonth()      
      }

      const selectToday = (e) => {
        view === 'Day view' &&  jumpToToday(e)
        view === 'Week view' && changeWeek(startOfToday())
        view === 'Month view' && setCurrentMonth(format(startOfToday(), 'MMMM yyyy'))
      }

      const returnTimezoneSafeDate = (day) => {
        let formattedDate = typeof day === 'string' ? day : format(day, 'yyyy-MM-dd')
        const [year, month, date] = formattedDate.split('-').map(Number);
        const newDate = new Date(year, month - 1, date);
        return newDate
      }


    return(
        <header className="flex flex-none items-center justify-between border-gray-200 py-0 px-6 pl-0">
            <div className="flex justify-between w-full">
              <div className='flex w-1/2'>
                <div className='w-1/3'>
                  <h1 className="text-lg font-semibold m-0 leading-6 text-gray-900">
                    <time dateTime="2022-01-22" className="sm:hidden">{format(returnTimezoneSafeDate(selectedDay.date), 'MMM')} {format(returnTimezoneSafeDate(selectedDay.date), 'd')}</time>
                    {view === 'Day view' ?
                          <time dateTime="2022-01-22" className="hidden sm:inline">{format(returnTimezoneSafeDate(selectedDay.date), 'MMMM')} {format(returnTimezoneSafeDate(selectedDay.date), 'd')}, {format(returnTimezoneSafeDate(selectedDay.date), 'yyyy')}</time>
                    : <time dateTime="2022-01">{currentMonth ? currentMonth : monthName}</time>
                    }
                  </h1>
                  {view === 'Day view' && <p className="mt-1 text-sm m-0 p-0 text-gray-500">{format(returnTimezoneSafeDate(selectedDay.date), 'EEEE')}</p>}
                </div>
                <div className="flex items-center rounded-md shadow-sm md:items-stretch">
                  <button onClick={() => flipBack(subDays(returnTimezoneSafeDate(selectedDay.date), 1))} type="button" className="flex items-center justify-center rounded-l-md border border-r-0 border-gray-300 bg-white py-2 pl-3 pr-4 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:px-2 md:hover:bg-gray-50">
                    <span className="sr-only">Previous month</span>
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                  <button onClick={() => selectToday(startOfToday())} type="button" className="hidden border-t border-b border-l-0 border-r-0 border-gray-300 bg-white px-3.5 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900 focus:relative md:block">
                    Today
                  </button>
                  <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden" />
                  <button onClick={() => flipForward(addDays(returnTimezoneSafeDate(selectedDay.date), 1))} type="button" className="flex items-center justify-center rounded-r-md border border-l-0 border-gray-300 bg-white py-2 pl-4 pr-3 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:px-2 md:hover:bg-gray-50">
                    <span className="sr-only">Next month</span>
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                </div>
              </div>
              <div className='ml-auto'>
                <div className='bg-gray-100 rounded-lg border border-solid border-gray-300'>
                  <div onClick={() => setView('Day view')} className={classNames(view === 'Day view' && 'bg-white border border-solid border-gray-300 shadow-md', 'inline-block my-1 mx-2 font-md py-1 px-4 rounded-lg  cursor-pointer')}>Day</div>
                  <div onClick={() => setView('Week view')} className={classNames(view === 'Week view' && 'bg-white border border-solid border-gray-300 shadow-md', 'inline-block my-1 mx-2 font-md py-1 px-4 rounded-lg cursor-pointer')}>Week</div>
                  <div onClick={() => setView('Month view')} className={classNames(view === 'Month view' && 'bg-white border border-solid border-gray-300 shadow-md', 'inline-block my-1 mx-2 font-md py-1 px-4 rounded-lg cursor-pointer')}>Month</div>
                </div>
              </div>
              <div className="hidden md:ml-4 md:flex md:items-center">
                {/* <Menu as="div" className="relative">
                  <Menu.Button
                    type="button"
                    className="flex items-center rounded-md border border-gray-300 bg-white py-2 pl-3 pr-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                  >
                    Day view
                    <ChevronDownIcon className="ml-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                  </Menu.Button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-3 w-36 origin-top-right overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              onClick={() => setView('Day view')}
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm'
                              )}
                            >
                              Day view
                            </a>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              onClick={() => setView('Week view')}
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm'
                              )}
                            >
                              Week view
                            </a>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              onClick={() => setView('Month view')}
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm'
                              )}
                            >
                              Month view
                            </a>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              onClick={() => setView('Year view')}
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm'
                              )}
                            >
                              Year view
                            </a>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu> */}
                {/* <div className="ml-6 h-6 w-px bg-gray-300" />
                <button
                  type="button"
                  className="ml-6 rounded-3xl border border-transparent bg-purple-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  Add Event
                </button>
                <button
                type="button"
                onClick={() => props.createNewPendingOffer()}
                className="ml-6 rounded-md border border-transparent bg-indigo-400 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                Add Block
              </button> */}
              </div>
              <Menu as="div" className="relative ml-6 md:hidden">
                <Menu.Button className="-mx-2 flex items-center rounded-full border border-transparent p-2 text-gray-400 hover:text-gray-500">
                  <span className="sr-only">Open menu</span>
                  <EllipsisHorizontalIcon className="h-5 w-5" aria-hidden="true" />
                </Menu.Button>
                <Transition as={React.Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                  <Menu.Items className="absolute right-0 z-10 mt-3 w-36 origin-top-right divide-y divide-gray-100 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                      <Menu.Item>
                        {({ active }) => (<a href="#" className={classNames( active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>Create event</a>)}
                      </Menu.Item>
                    </div>
                    <div className="py-1">
                      <Menu.Item>
                        {({ active }) => (<a href="#" className={classNames( active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>Go to today</a>)}
                      </Menu.Item>
                    </div>
                    <div className="py-1">
                      <Menu.Item>
                        {({ active }) => (<a href="#" onClick={() => setView('Day view')} className={classNames( active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>Day view</a>)}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (<a href="#" onClick={() => setView('Week view')} className={classNames( active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>Week view</a>)}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (<a href="#" onClick={() => setView('Month view')} className={classNames( active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>Month view</a>)}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (<a href="#" onClick={() => setView('Year view')} className={classNames( active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>Year view</a>)}
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </header>
    )
}
export default InternalCalendarMenu